import { Caja } from "./caja";
import { ArqueoCaja } from './arqueo_caja';
import { Usuario } from './usuario';

export class AsignacionCaja {
    constructor(
        public id: String = "",
        public empresa_id: String = "",
        public sucursal_id: String = "",
        public caja_id: String = "",
        public tipo: String = "",
        public fecha: String = "",
        public status: String = "",
        public fecha_ingreso: String = "",
        public usuario_id: String = "",
        public fecha_modifica: String = "",
        public usuario_modifica_id: String = "",
        public fecha_elimina: String = "",
        public usuario_elimina_id: String = "",

        

        public caja: Caja = new Caja(),
        public arqueos: Array<ArqueoCaja> = [],
        public usuario: Usuario = new Usuario(),
        )
         
	{}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/asignacion-caja.ts